import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Menu, MenuItem, Container } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import logo from '../assets/logo.jpg';
import classes from './Header.module.css';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static" elevation={0} className={classes.header} style={{ backgroundColor: '#fff', color: '#000', borderBottom: '1px solid #e0e4ed' }}>
      <Container maxWidth={false} disableGutters sx={{ px: { xs: 2, md: 4 } }}>
        <Toolbar disableGutters className={classes.inner} style={{ fontFamily: 'Roboto, sans-serif' }}>
          <Link to = '/'>
            <img src={logo} alt="Company Logo" className={classes.logo} />
          </Link>
          {!isMobile && (
            <div className={classes.desktopMenu}>
              <Typography variant="h6" component="a" href="/" className={classes.link}>
                Home
              </Typography>
              <Typography variant="h6" component="a" href="/ai" className={classes.link}>
                AI
              </Typography>
              <Typography variant="h6" component="a" href="/renewable-energy" className={classes.link}>
                Renewable Energy
              </Typography>
              <Typography variant="h6" component="a" href="/technology" className={classes.link}>
                Technology
              </Typography>
              <Typography variant="h6" component="a" href="/battery" className={classes.link}>
                Battery
              </Typography>
              <Typography variant="h6" component="a" href="/services" className={classes.link}>
                Services
              </Typography>
              <Typography variant="h6" component="a" href="/trading" className={classes.link}>
                Trading
              </Typography>
            </div>
          )}
          {isMobile && (
            <>
              <IconButton edge="end" color="inherit" aria-label="menu" onClick={handleMenuOpen} className={classes.mobileMenuButton}>
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                className={classes.mobileMenu}
              >
                <MenuItem onClick={handleMenuClose} component="a" href="/">Home</MenuItem>
                <MenuItem onClick={handleMenuClose} component="a" href="/ai">AI</MenuItem>
                <MenuItem onClick={handleMenuClose} component="a" href="/renewable-energy">Renewable Energy</MenuItem>
                <MenuItem onClick={handleMenuClose} component="a" href="/technology">Technology</MenuItem>
                <MenuItem onClick={handleMenuClose} component="a" href="/battery">Battery</MenuItem>
                <MenuItem onClick={handleMenuClose} component="a" href="/services">Services</MenuItem>
                <MenuItem onClick={handleMenuClose} component="a" href="/trading">Trading</MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;